import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  AnfrageDto, PreviewMatchRequest, PreviewMatchResponse, SubmitAnfrageRequest,
} from '../models/anfrage.model';

export interface PhotoUploadResponse { url: string; }

/**
 * BFF client for the Anfrage endpoints.
 * Cookie auth is attached automatically by the global credentials interceptor.
 */
@Injectable({ providedIn: 'root' })
export class AnfrageService {
  private readonly http = inject(HttpClient);

  uploadPhoto(file: File): Observable<PhotoUploadResponse> {
    const fd = new FormData();
    fd.append('file', file, file.name);
    return this.http.post<PhotoUploadResponse>('/api/anfragen/photos', fd);
  }

  previewMatch(request: PreviewMatchRequest): Observable<PreviewMatchResponse> {
    return this.http.post<PreviewMatchResponse>('/api/anfragen/preview-match', request);
  }

  submit(request: SubmitAnfrageRequest): Observable<AnfrageDto> {
    return this.http.post<AnfrageDto>('/api/anfragen', request);
  }

  getById(id: string): Observable<AnfrageDto> {
    return this.http.get<AnfrageDto>(`/api/anfragen/${id}`);
  }

  /** Soft-removes the (Anfrage × Handwerker) match by setting it to RejectedByCustomer. */
  removeMatch(anfrageId: string, handwerkerId: string): Observable<AnfrageDto> {
    return this.http.delete<AnfrageDto>(
      `/api/anfragen/${anfrageId}/matches/${handwerkerId}`,
    );
  }

  /** Transitions MatchedToBetriebe → OffersOpen. */
  finalize(anfrageId: string): Observable<AnfrageDto> {
    return this.http.post<AnfrageDto>(`/api/anfragen/${anfrageId}/finalize`, {});
  }
}
